import fetch from '../config/api'
/**
 * 搜索接口
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {keyword} 关键字
 */
const Search = (language = '1', keyword) => fetch('/search', {
    p: 'wx',
    language,
    keyword
});
export default {
    Search
}